import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import TextField from '@mui/material/TextField';

import {
  editComment,
  editSubcomment,
  likeAnswerFunction,
  likePostFunction
} from 'store/lesson-actions';

import classes from './CommentPost.module.css';

const CommentPost = props => {
  const { t } = useTranslation(['forum']);
  const [postText, setPostText] = useState(
    props.commentData.message
  );
  const [likeComment, setLikeComment] = useState(
    props.commentData.userLike === 1 ? true : false
  );
  const [likes, setLikes] = useState(props.commentData.likes);

  const likeCommentHandler = () => {
    setLikeComment(!likeComment);
    if (!likeComment === false) {
      setLikes(likes - 1);
    } else {
      setLikes(likes + 1);
    }
    if (props.subcomment) {
      (async () => {
        await likeAnswerFunction(props.idComment, !likeComment);
      })();
    } else {
      (async () => {
        await likePostFunction(props.idComment, !likeComment);
      })();
    }
  };

  const showResponseCommentHandler = () => {
    props.responseComment();
  };

  const showAnswersHandler = () => {
    props.showAnswers();
  };

  const handleChange = event => {
    setPostText(event.target.value);
  };

  const editPostHandler = () => {
    (async () => {
      if (props.subcomment) {
        await editSubcomment(props.idComment, postText);
      } else {
        await editComment(props.idComment, postText);
      }
      props.editCommentHandler();
    })();
  };

  return (
    <>
      <figure className={classes.userImageContainer}>
        {props.commentData.urlImage ? (
          <img
            className={classes.userImage}
            src={props.commentData.urlImage}
            alt={props.commentData.fullname}
          />
        ) : (
          <img
            className={classes.userImage}
            src="https://d1g6c01s9ssd7h.cloudfront.net/img/usuario12.png"
            alt={props.commentData.fullname}
          />
        )}
      </figure>
      <p className={classes.userNameComment}>
        {props.commentData.fullname}
      </p>
      <TextField
        multiline
        value={postText}
        disabled={!props.editComment}
        className={classes.forumInput}
        onChange={handleChange}
      />
      <div className={classes.complementaryInfoContainer}>
        {!props.editComment ? (
          <>
            {likeComment ? (
              <IconButton
                className={classes.likeBtn}
                onClick={likeCommentHandler}
              >
                <ThumbUpIcon className={classes.likeIcon} />
              </IconButton>
            ) : (
              <IconButton
                className={classes.likeBtn}
                onClick={likeCommentHandler}
              >
                <ThumbUpOutlinedIcon className={classes.likeIcon} />
              </IconButton>
            )}
            <span>
              {likes} {!props.subcomment && '-'}
            </span>
            {!props.subcomment && (
              <>
                <Button
                  className={classes.complementaryBtn}
                  onClick={showResponseCommentHandler}
                >
                  {t('reply')}
                </Button>
                <Button
                  className={classes.complementaryBtn}
                  disabled={props.commentData.comments === 0}
                  onClick={showAnswersHandler}
                >
                  {t('see')} {props.commentData.comments}{' '}
                  {t('answers')}
                </Button>
              </>
            )}
          </>
        ) : (
          <Button
            className={classes.editPostBtn}
            onClick={editPostHandler}
          >
            {t('edit')}
          </Button>
        )}
      </div>
    </>
  );
};

CommentPost.propTypes = {
  // eslint-disable-next-line react/require-default-props
  commentData: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  responseComment: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  editComment: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  showAnswers: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  idComment: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  editCommentHandler: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  subcomment: PropTypes.bool
};

export default CommentPost;
